import type { ComponentProps } from 'react';

import type { Breadcrumbs } from '@change/ds-core-ui';

import { useI18n } from '@change-corgi/core-react/i18n';

import { usePetitionGuidesCategoryPageData } from '#src/app/pages/petitionGuides/category/details/pageContext';

type Result = ModelHookResult<{
	items: ComponentProps<typeof Breadcrumbs>['items'];
}>;

export function useCategoryBreadcrumbs(): Result {
	const { translate } = useI18n();
	const {
		data: { name },
	} = usePetitionGuidesCategoryPageData();

	return {
		data: {
			items: [
				{
					label: translate('corgi.petition_guides_category_page.breadcrumbs.home'),
					href: '/',
				},
				{
					label: translate('corgi.petition_guides_category_page.breadcrumbs.guides'),
					href: '/petition-guides',
				},
				{ label: name ?? translate('corgi.petition_guides_category_page.breadcrumbs.all') },
			],
		},
	};
}
